import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTable, SkAlertBanner } from './_primitives';

/** SegmentationPage — 4 stats (Active Segments/Members/At-Risk/Avg Engagement), segments table */
const SegmentationPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <SkAlertBanner />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default SegmentationPageLoader;
